import { API_PUBLIC_HOST, S3_HOST, languageCode } from "@/_constant";
import api from "./request";
import axios from "axios";
const COUNTRY_CODES_URL = `${S3_HOST}/country/countrycodes.json`

export function uploadMediaFile(formData) {
  return new Promise((resolve, reject) => {
    if (!(formData instanceof FormData)) {
      reject(new Error("Invalid input: formData must be an instance of FormData"));
      return;
    }
    const url = `${API_PUBLIC_HOST}/mediaAccess/upload`;
    api.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "accept": "application/json",
        },
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export function deleteMediaFile(mediaAssetId){
  return new Promise((resolve, reject) => {
    const url = `${API_PUBLIC_HOST}/mediaAccess/delete?mediaAssetId=${mediaAssetId}`;
    api.delete(url)
    .then(response => resolve(response))
    .catch(error=> reject(error))
  });
}

export const translateWithGoogle = async (text, lang) => {
  const res = await axios(`https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${languageCode(lang)}&dt=t&q=${encodeURIComponent(text)}`);
  const data = await res.data;
  console.log(data);
  return data[0]?.[0]?.[0] ?? "";
};

export const fetchCountries = () => {
  return new Promise(async (resolve, reject)=>{
    try {
      const response = await fetch(COUNTRY_CODES_URL);
      const data = await response.json();
      resolve(data);
    }catch(err){
      reject(err);
    }
  })
}

export const fetchLocation = (type, query) => {
  let url = `${API_PUBLIC_HOST}/lookup/location?type=${type}`;
  if (query) {
      url += `&query=${query}`;
  }
  return api.get(url);
}

export const fetchUserStats = () => {
  const url = `${API_PUBLIC_HOST}/dashboard/adZoneStatistics`;
  return api.get(url);
}